import "./buttonGroup.css";

type BtnArray = BtnInstance[];
type BtnInstance = {
  type?: "button" | "submit" | "reset";
  text: any;
  svgBefore?: any;
  svgAfter?: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function ButtonGroup({ btnArray }: { btnArray: BtnArray }) {
  return (
    <div className="btn-group">
      {btnArray.map((item, index) => (
        <button
          type={item.type || "button"}
          onClick={item.onClick}
          className={`btn btn-main ${index === 0 && btnArray.length > 1 && `first`}
          ${index === btnArray.length - 1 && btnArray.length > 1 && `last`}`}
          key={Math.random() * 100}
        >
          {item.svgBefore && (
            <div style={{ marginRight: 5, display: "flex" }}>{item.svgBefore}</div>
          )}{" "}
          {item.text}{" "}
          {item.svgAfter && <div style={{ marginLeft: 5, display: "flex" }}>{item.svgAfter}</div>}
        </button>
      ))}
    </div>
  );
}
